module.exports = __webpack_public_path__ + "assets/img/news-2.c42bd5b8.jpg";